const sans = "Poppins, sans-serif";

const fonts = {
  heading: sans,
  body: sans,
  mono: sans,
};

export default fonts;
